import { PRACTICE_INTRO_DISMISS, PRACTICE_INTRO_LINES, PRACTICE_INTRO_TITLE } from '../../shared/practiceCopy';

/**
 * v28 BOLT-151 — the captive practice explainer.
 *
 * CAPTIVE means captive: the backdrop takes the tap and does nothing with it.
 * A modal you can dismiss by tapping around it is a modal most people dismiss
 * by accident, which is how we got here (a hint nobody reads).
 *
 * It teaches, it does not gate. Nothing in the round waits on it - the head
 * start is already counting down behind this - so there is no send, no timer
 * and no state change on dismiss beyond closing it.
 */
export function PracticeIntro({ onDismiss }: { onDismiss: () => void }) {
  return (
    <div className="practice-intro" data-testid="practice-intro" role="dialog" aria-modal="true" aria-label={PRACTICE_INTRO_TITLE}>
      <div className="practice-intro__card">
        <div className="practice-intro__title">{PRACTICE_INTRO_TITLE}</div>
        <div className="practice-intro__body">
          {PRACTICE_INTRO_LINES.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>
        <button className="btn btn--signal btn--lg" data-testid="practice-intro-dismiss" autoFocus onClick={onDismiss}>
          {PRACTICE_INTRO_DISMISS}
        </button>
      </div>
    </div>
  );
}
